module.exports = __webpack_public_path__ + "assets/img/C3.2bdc4a25.png";